import { AdminLegalPagesResponseSchema, LegalLinksResponseSchema, LegalPageResponseSchema, type LegalKey } from '@couch/shared';
import { empty, json } from './client';

/** The legal pages (doc 63). */
export const legalApi = {
  links: () => json(LegalLinksResponseSchema, 'GET', '/legal'),
  page: (key: LegalKey) => json(LegalPageResponseSchema, 'GET', `/legal/${key}`),
  adminPages: () => json(AdminLegalPagesResponseSchema, 'GET', '/admin/legal'),
  save: (key: LegalKey, body: string) => empty('PUT', `/admin/legal/${key}`, { body }),
};

export const LEGAL_LINKS_KEY = ['legal-links'] as const;
export const ADMIN_LEGAL_KEY = ['admin-legal'] as const;
